import { axiosCreate } from "@config/index"
import { verifyBodyResponse } from "@thelpers/verifyBodyResponse"

export const getChargesFromCompany = async ({
    token,
    company_id,
    charge_status_id,
    limit = 10,
    skip = 0,
    sort_by,
    sort_order,
}) => {
    const params = {
        company_id,
        charge_status_id,
        limit,
        skip,
        sort_by,
        sort_order,
    }

    try {
        const res = await axiosCreate.get('/charge', {
            params,
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })

        return verifyBodyResponse(res, true)
    } catch (error) {
        console.error(error)
        return verifyBodyResponse(error, false)
    }
}